import React, { useState } from "react";

interface LogoutProps {}

const LogOutPage: React.FC<LogoutProps> = () => {

  return (
   <>
   </>
  );
};

export default LogOutPage;

